import type { MemberTopupSubscribeProduct } from '../configs/types'
import { VIP_TYPE } from '@/constants'
import { SubscriptionCycle } from '@/utils/enum'

type Translate = (key: string, params?: Record<string, any>) => string

// 周期 -> 「首个周期」文案 key(带优惠文案的 {cycle} 片段,如 en: the first week)
const FIRST_CYCLE_TEXT_KEYS: Record<number, string> = {
  [SubscriptionCycle.OneDay]: 'SubscribeTextCycleOneDay',
  [SubscriptionCycle.ThreeDays]: 'SubscribeTextCycleThreeDays',
  [SubscriptionCycle.WEEK]: 'SubscribeTextCycleWeek',
  [SubscriptionCycle.MONTH]: 'SubscribeTextCycleMonth',
  [SubscriptionCycle.SEASON]: 'SubscribeTextCycleSeason',
  [SubscriptionCycle.HALF_YEAR]: 'SubscribeTextCycleHalfYear',
  [SubscriptionCycle.YEAR]: 'SubscribeTextCycleYear',
}

function toPrice(value: unknown): number | null {
  if (value === null || value === undefined || value === '')
    return null

  const num = Number(value)
  return Number.isFinite(num) ? num : null
}

/**
 * 非广告用户畅读会员的客户端价格说明文案(ZKSN-251)。
 *
 * 返回 null 表示保持接口返回的 subscribeText:
 * 折扣会员、免费档(preferentialPrice 为 0)、数据异常(价格/周期缺失)均不覆写。
 */
export function getNaturalUserSubscribeText(item: MemberTopupSubscribeProduct, t: Translate): string | null {
  if (Number(item.subscribeType) !== VIP_TYPE.ALL)
    return null

  const price = toPrice(item.price)
  if (price === null)
    return null

  const preferentialPrice = toPrice(item.preferentialPrice)
  if (preferentialPrice === null)
    return t('SubscribeTextNormal', { price })

  if (preferentialPrice === 0)
    return null

  const cycleKey = FIRST_CYCLE_TEXT_KEYS[item.cycle]
  if (!cycleKey)
    return null

  return t('SubscribeTextPreferential', {
    price: preferentialPrice,
    cycle: t(cycleKey),
    originalPrice: price,
  })
}
